<!-- eslint-disable -->
<template>
    <div class="contact-container">
        <h1 class="titre">{{ $t('contact') }}</h1>
        <div class="contact-info">
            <p><strong>{{ $t('email') }}</strong> <a href="mailto:info@supermileagequebec.com"> info@supermileagequebec.com</a></p>
            <p><strong>{{ $t('phone') }}</strong> (418) 714-8671</p>
            <p><strong>{{ $t('addressSm') }}</strong> 1065 avenue de la médecine</p>
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line
    name: 'Contact'
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contact-container {
    max-width: 800px;
    margin: 65px auto;
    padding: 100px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.titre{
    font-family: Rubik bold;
    letter-spacing: 0.05em;
    color: #193300; 
}

.contact-info {
    font-size: 1.3em;
    font-family: Lato;
    margin-top: 30px;
}

.contact-info p {
    margin: 10px 0;
}

.contact-info a {
    color: #5fbf00;
    text-decoration: none;
}

.contact-info a:hover {
    text-decoration: underline;
}
</style>
